// import store from '../store';
import axios from 'axios';
import config from '../conf/config';
import {hasValue} from '../utils/utils';

export const possibleMethods = {
    GET: 'GET',
    POST: 'POST',
    DELETE: 'DELETE',
    PATCH: 'PATCH',
    PUT: 'PUT',
}

export function fetchFromSMP(url, method, fetchOptions = {}, headers = {}) {
    return new Promise((resolve, reject) => {
        // Default method is GET, if method not one of possible methods, set as GET
        let methodForAxios = method.toUpperCase();
        if (!Object.keys(possibleMethods).includes(methodForAxios)) {
            methodForAxios = possibleMethods.GET;
        }
        const requestHeaders = {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'application/json',
            ...headers
        }
        // Add authentication key to header
        // if (isAuthenticated()) {
        //     requestHeaders['X-chkp-sid'] = getAccessToken();
        // }

        axios.request({
            baseURL: config.api_base_url,
            url: url,
            method: methodForAxios,
            headers: requestHeaders,
            params: fetchOptions.params,
            data: fetchOptions.data,
            timeout: hasValue(fetchOptions.timeout) ? fetchOptions.timeout : config.api_request_timeout,
            withCredentials: true
        })
        .then(response => {
            return resolve(response);
        })
        .catch(error => {
            return reject(error);
        });

    });
}